import api from "./api";
import { setAxiosHeader, setAxiosHeader4Post } from "./serviceMain";

export type newPassword = {
    newPassword: string;
}

export async function changeAccountPassword(newPassword: string) {

//   const headers: AxiosHeaders = new AxiosHeaders()
//   headers.set('Content-Type', 'application/json');
//   headers.set('Access-Control-Allow-Origin', '*');
//   headers.set('Accept', 'application/json');

const body = {
    newPassword: newPassword,
  };

  const url = '/v3/account/changepassword';

  let status:number = 0;

  await api.post(`${url}`,JSON.stringify(body), { 
    headers: setAxiosHeader4Post(body) 
    }).then((response)=> {
    status = response?.status;
  });

  if(status === 200) {
    return 'OK';
  } else {
    return 'KO';
  }

};